// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './axios'
import YDUI from 'vue-ydui' /* 相当于import YDUI from 'vue-ydui/ydui.rem.js' */
import 'vue-ydui/dist/ydui.rem.css'
import store from './store'
import common from './util/common.js'
import lbtoolds from './util/lbtools.js'
import Navigation from 'vue-navigation'
import outils from 'outils' // 工具集合 https://github.com/proYang/outils
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import BaiduMap from 'vue-baidu-map'

Vue.use(YDUI)
Vue.use(common)
Vue.use(Navigation, {
	router,
	store
})
Vue.component('icon', Icon)
Vue.use(BaiduMap, {
	// ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
	// ak: 'FWTCliAdzlBpFRQqPpYePrt2BgNTGDb2',
	ak: 'mXuXqYv1eaRjMQXhKivrQMo5pTzekQnG',
})
Vue.prototype.$outils = outils
Vue.prototype.$lbtools = lbtoolds

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
})
router.beforeEach((to, from, next) => {
	window.document.title = to.meta.title // 设置页码的title
	if (to.matched.some(record => record.meta.requireLogin)) {
		// store已存在用户信息直接进入页面
		if (store.state.token !== '') {
			next()
		} else {
			// 去微信授权登录
			if (process.env.NODE_ENV === 'development') {
				next({
					path: '/Wxlogin',
					query: {
						redirect: to.fullPath
					}
				})
			} else {
				next({
					path: '/Oauth',
					query: {
						redirect: to.fullPath
					}
				})
			}
		}
	} else {
		next()
	}
})



// WEBPACK FOOTER //
// ./src/main.js